export class AssetActivityControlRequest {
    assetCode: string;
    tubCode: string;
    createdUser: string;
    date: string;
    cronJobTime: string;
    jobId: string;
    assetControl:boolean;
}